import { render, staticRenderFns } from "./setting-edit.vue?vue&type=template&id=43ce2074&scoped=true"
import script from "./setting-edit.vue?vue&type=script&lang=js"
export * from "./setting-edit.vue?vue&type=script&lang=js"
import style0 from "./setting-edit.vue?vue&type=style&index=0&id=43ce2074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce2074",
  null
  
)

export default component.exports